import { jsx as x, jsxs as w } from "react/jsx-runtime";
import { c as b } from "react/compiler-runtime";
const M = (v) => {
  const t = b(14), {
    scale: m,
    dimensions: c,
    fill: p,
    text: u
  } = v, i = m === void 0 ? 1 : m, e = p === void 0 ? "white" : p, d = u === void 0 ? "4G" : u, a = (c.base - c.icon * i) / 2, r = (c.base - c.icon * i) / 2, h = c.icon * i, f = c.icon * i;
  let o, s;
  t[0] !== e ? (o = /* @__PURE__ */ x("path", { fill: e, d: "m7.3 14.7 1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7M19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9s-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1s-1-5.1-2.9-7.1" }), s = /* @__PURE__ */ x("path", { fill: e, d: "M6.1 4.1 4.9 2.9C3 4.9 2 7.4 2 10s1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9s.8-4.3 2.4-5.9m10.6 10.6c1.3-1.3 2-3 2-4.7-.1-1.7-.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5zM14.5 10c0-1.38-1.12-2.5-2.5-2.5S9.5 8.62 9.5 10c0 .76.34 1.42.87 1.88L7 22h2l.67-2h4.67l.66 2h2l-3.37-10.12c.53-.46.87-1.12.87-1.88m-4.17 8L12 13l1.67 5z" }), t[0] = e, t[1] = o, t[2] = s) : (o = t[1], s = t[2]);
  let l;
  t[3] !== e || t[4] !== d ? (l = /* @__PURE__ */ x("text", { x: "50%", y: "4.4", fontSize: "6px", textAnchor: "middle", fill: e, children: d }), t[3] = e, t[4] = d, t[5] = l) : l = t[5];
  let n;
  return t[6] !== l || t[7] !== a || t[8] !== r || t[9] !== h || t[10] !== f || t[11] !== o || t[12] !== s ? (n = /* @__PURE__ */ w("svg", { focusable: "false", "aria-hidden": "true", viewBox: "0 0 24 24", "data-testid": "CellTowerIcon", x: a, y: r, width: h, height: f, children: [
    o,
    s,
    l
  ] }), t[6] = l, t[7] = a, t[8] = r, t[9] = h, t[10] = f, t[11] = o, t[12] = s, t[13] = n) : n = t[13], n;
};
export {
  M as default
};
